import React from "react";

function TextInput({
  id,
  type = "text",
  placeholder,
  value,
  onChange,
  className = "",
  autoComplete,
  required = false,
}) {
  return (
    <input
      id={id}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      autoComplete={autoComplete}
      required={required}
      className={`w-full rounded-lg border border-greyLight bg-white py-3 px-5 font-josefin text-secondaryText placeholder:text-greyLight outline-none focus:border-primaryDark ${className}`}
    />
  );
}

export default TextInput;
